import { render, staticRenderFns } from "./note-column.vue?vue&type=template&id=221f520c&scoped=true"
import script from "./note-column.vue?vue&type=script&lang=js"
export * from "./note-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f520c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221f520c')) {
      api.createRecord('221f520c', component.options)
    } else {
      api.reload('221f520c', component.options)
    }
    module.hot.accept("./note-column.vue?vue&type=template&id=221f520c&scoped=true", function () {
      api.rerender('221f520c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/columns/note-column.vue"
export default component.exports